/**
 * O código do aparelho (29/10/2026): um número aleatório sorteado na primeira vez que
 * o app abre neste navegador (ou dentro do app instalado), mandado em todo pedido à
 * API no cabeçalho `X-Wt-Aparelho`. Não lê nada do aparelho: é só um sorteio nosso.
 *
 * Serve para a API barrar o APARELHO de quem foi banido e volta com outra conta e
 * outra internet (`api/src/protecao/aparelho.service.ts`). Fica guardado em dois
 * lugares, o armazenamento do site e um cookie de reserva, para que limpar um só não
 * troque o código. O "Sair" não apaga esta chave: o código é do aparelho, não da conta.
 */
const CHAVE = "wt_aparelho"
const FORMATO = /^apr_[A-Za-z0-9_-]{16,40}$/
/* 400 dias, o teto que o Chrome aceita para um cookie. Cada abertura do app renova. */
const VALIDADE_DO_COOKIE_S = 400 * 24 * 60 * 60

let emMemoria: string | null = null

function sortear(): string {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  let binario = ""
  bytes.forEach((b) => {
    binario += String.fromCharCode(b)
  })
  return "apr_" + btoa(binario).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

function lerDoArmazenamento(): string | null {
  try {
    const valor = window.localStorage.getItem(CHAVE)
    return valor && FORMATO.test(valor) ? valor : null
  } catch {
    return null
  }
}

function lerDoCookie(): string | null {
  try {
    const par = document.cookie.split("; ").find((p) => p.startsWith(`${CHAVE}=`))
    const valor = par ? decodeURIComponent(par.slice(CHAVE.length + 1)) : null
    return valor && FORMATO.test(valor) ? valor : null
  } catch {
    return null
  }
}

function guardar(codigo: string) {
  try {
    window.localStorage.setItem(CHAVE, codigo)
  } catch {
    /* Navegador que não deixa guardar (aba anônima antiga): fica o cookie e a memória. */
  }
  try {
    const seguro = window.location.protocol === "https:" ? "; Secure" : ""
    document.cookie = `${CHAVE}=${encodeURIComponent(codigo)}; Max-Age=${VALIDADE_DO_COOKIE_S}; Path=/; SameSite=Lax${seguro}`
  } catch {
    /* idem */
  }
}

/** O código deste aparelho. Nulo só no servidor ou num navegador sem sorteio seguro. */
export function codigoDoAparelho(): string | null {
  if (typeof window === "undefined") return null
  if (emMemoria) return emMemoria
  const salvo = lerDoArmazenamento() ?? lerDoCookie()
  const codigo = salvo ?? (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function" ? sortear() : null)
  if (!codigo) return null
  emMemoria = codigo
  /* Repõe o lugar que estiver vazio e renova o cookie. */
  guardar(codigo)
  return codigo
}

/** O cabeçalho para juntar aos de um `fetch` que não passa pelo `apiFetch`. */
export function cabecalhoDoAparelho(): Record<string, string> {
  const codigo = codigoDoAparelho()
  return codigo ? { "X-Wt-Aparelho": codigo } : {}
}
